var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$slots.default ? _c('ul', {
    directives: [{
      name: "preventAndroidScroll",
      rawName: "v-preventAndroidScroll"
    }],
    staticClass: "horizontal-scroll"
  }, [_vm.$slots.default[0].tag === 'li' ? [_vm._t("default")] : _vm._l(_vm.$slots.default, function (item, index) {
    return !item.isComment && (_vm.$slots['temp' + index] = item) ? _c('li', [_vm._t('temp' + index)], 2) : _vm._e();
  })], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };